import "./Header.scss";

const FooterDashboard = () => {
    return (
        <>
            <div className="footer-top no-fixed">
                Website belongs to
                Department of School Education & Literacy,
                Ministry of Education.
                Designed, Developed and Hosted by
                National Informatics Centre ( NIC )
            </div>
        </>
    )
}


export default FooterDashboard